import { render, staticRenderFns } from "./bnLivraisonFour.vue?vue&type=template&id=5b3ffb8e&"
import script from "./bnLivraisonFour.vue?vue&type=script&lang=js&"
export * from "./bnLivraisonFour.vue?vue&type=script&lang=js&"
import style0 from "./bnLivraisonFour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports